module.exports = __webpack_public_path__ + "058e7728ef7a14558de30e1107abe750.jpg";